export const TEST_ID = 'droneDetailsPage';

export const CARD_HEADER_DETAIL_TYPE = 'drone';

export const DETAIL_TYPE_FAA_REGISTRATION_NUMBER = 'faaRegistrationNumber';

export const DETAIL_TYPE_FLIGHT_HOURS = 'flightHours';

export const DETAIL_TYPE_NUMBER_OF_FLIGHTS = 'numberOfFlights';

export const DETAIL_TYPE_CONTROLLER_SERIAL_NUMBER = 'controllerSerialNumber';

export const DETAIL_TYPE_WARRANTY_START_DATE = 'warrantyStartDate';

export const DETAIL_TYPE_WARRANTY_END_DATE = 'warrantyEndDate';

export const DETAIL_TYPE_WARRANTY_REMAINING = 'warrantyRemaining';

export const DETAIL_TYPE_STATUS = 'status';

export const DETAIL_TYPE_TOTAL_ACRES = 'totalAcres';

export const DETAIL_TYPE_DRONE_SERIAL_NUMBER = 'droneSerialNumber';

export const DETAIL_TYPE_FLIGHT_CONTROLLER_FIRMWARE_VERSION = 'flightControllerFirmwareVersion';
